module.exports = __webpack_public_path__ + "static/media/Alessandro.1ee7caf4.png";